import React, { Component } from 'react';
import { Card, Divider, Button } from 'semantic-ui-react';
import axios from 'axios'
import { serverIp, toCurrency, } from '../../../../config/constants';


class PhoneMoneyLogTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
        }
    }

    componentDidMount() {
        console.log("cpx1 ======componentDidMount");
    }

    ackTrans = () => {
        console.log("cpx1 ======ackTrans");

        this.setState({ loading: true })

        axios.post(serverIp + 'salesApp/ackPhoneMoneyLog', {
            apiKey: "ackPhoneMoneyLog",
            idphoneMoneyLog: this.props.item.idphoneMoneyLog,
            enteredBy: this.props.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. ackTrans");
                    this.props.getTransactions();

                    alert(response.data.message);
                } else {
                    console.log("FAILED");
                    alert("FAILED TO ackTrans:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const ackButton = this.props.item.ack && this.props.item.ack == 'no'
        ? <Button color='red' fluid onClick={this.ackTrans}>ACKNOWLEDGE</Button>
        : <Card.Header>ACKNOWLEDGED - {this.props.item.dateTimeAck} </Card.Header>

        return (<div>
            {/* <Table.Row>
                    <Table.Cell> {this.props.item.idphoneMoneyLog} </Table.Cell>
                    <Table.Cell positive>{this.props.item.dateDone}</Table.Cell>
                    <Table.Cell error>{toCurrency(this.props.item.amountSent)}</Table.Cell>
                    <Table.Cell positive>{this.props.item.action}</Table.Cell>
                    <Table.Cell >{this.props.item.sentTo}</Table.Cell>
                    <Table.Cell >{this.props.item.descriptionOf}</Table.Cell>
                    <Table.Cell >{toCurrency(this.props.phoneBalance)}</Table.Cell>
                </Table.Row> */}

            

            <Card>
                <Card.Content>
                    <Card.Header>#{this.props.item.idphoneMoneyLog} </Card.Header>
                    <Card.Header>DATE:{this.props.item.dateDone} </Card.Header>
                    <Card.Header>AMOUNT: {toCurrency(this.props.item.amountSent)} </Card.Header>
                    <Card.Header>ACTION:{this.props.item.action} </Card.Header>
                    <Card.Header>SENT TO:{this.props.item.sentTo} </Card.Header>
                    <Card.Header>REC'VD FROM:{this.props.item.receivedFrom} </Card.Header>
                    
                    <Card.Description>
                        {this.props.item.descriptionOf}
                    </Card.Description>
                    <Card.Header>PHONE BALANCE:{toCurrency(this.props.item.phoneBalance)} </Card.Header>
               
                    <Divider horizontal>{'COSTS / RECEIPT ENTERED'}</Divider>
                    {ackButton}
                    <br />
                </Card.Content>
            </Card>
            <br />
        </div>);
    }
}

export default PhoneMoneyLogTransactions;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/PhoneMoneyLog/PhoneMoneyLogTransactions.js